import { useMemo } from 'react'
import { useIntl } from 'react-intl'

import config from 'constants/config'
import productLabels from 'i18n/productLabels'

function usePurchaseSynonymLabels() {
  const intl = useIntl()
  const purchaseSynonym = config.brandConfig.purchaseSynonym

  return useMemo(() => {
    const myPurchases = (() => {
      if (purchaseSynonym === 'escape') {
        return intl.formatMessage(productLabels.myEscapes)
      }

      if (purchaseSynonym === 'booking') {
        return intl.formatMessage({
          id: 'uN-vVoJGfR6Xi1K4E_q6',
          defaultMessage: 'My Bookings',
          description: 'My escapes button text in navigation bar when purchaseSynonym is booking',
        })
      }

      return intl.formatMessage({
        id: '-QOPCZu2uRwE-x1yuuqc',
        defaultMessage: 'My Purchases',
        description: 'My escapes button text in navigation bar when purchaseSynonym is purchase',
      })
    })()

    return { myPurchases }
  }, [intl, purchaseSynonym])
}

export default usePurchaseSynonymLabels
